import React from 'react'
import { Link } from 'react-router-dom'
import SubmitButton from 'Components/Form/SubmitButton'

const SettingsTileUnstyled = ({
  className,
  label,
  linkLabel,
  path = ' ',
  onClick = false,
  href = false,
}) => (
  <div className={className}>
    <div>{label}</div>
    {onClick ? (
      <SubmitButton onClick={onClick} size="small">
        {linkLabel}
      </SubmitButton>
    ) : href ? (
      <a href={href} target="_blank" rel="noopener noreferrer">
        <SubmitButton size="small">{linkLabel}</SubmitButton>
      </a>
    ) : (
      <Link to={path}>
        <SubmitButton size="small">{linkLabel}</SubmitButton>
      </Link>
    )}
  </div>
)

export { SettingsTileUnstyled }
